import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
import axios from 'axios';

const initialState = {
  isSubmitting: false,
  error: null,
};

export const slice = createSlice({
  name: 'roo',
  initialState,
  reducers: {
    setSubmitting(state, action) {
      state.isSubmitting = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setSubmitting, hasError } = slice.actions;

export default slice.reducer;

// Submit Risks/Options/Opportunities form payload and download returned DOCX
export function submitRooAndDownloadDocx(payload) {
  const API_URL = process.env.REACT_APP_API_URL || '';
  const url = `${API_URL}/api/forms/roo/generate-docx`;
  return async () => {
    dispatch(slice.actions.setSubmitting(true));
    try {
      const response = await axios.post(url, payload, { responseType: 'blob' });

      // Determine filename from header; fallback to sensible default
      const cd = response.headers['content-disposition'];
      let filename = `ROO_${payload?.jobNumber || 'Document'}${payload?.revision ? `_Rev_${payload.revision}` : ''}.docx`;
      if (cd && cd.indexOf('attachment') !== -1) {
        const matches = /filename="?([^";]+)"?/i.exec(cd);
        if (matches && matches[1]) filename = matches[1];
      }

      const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      const fileURL = URL.createObjectURL(file);
      const tempLink = document.createElement('a');
      tempLink.href = fileURL;
      tempLink.setAttribute('download', filename);
      tempLink.style.display = 'none';
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      URL.revokeObjectURL(fileURL);

      return { filename };
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    } finally {
      dispatch(slice.actions.setSubmitting(false));
    }
  };
}


